@layer reset, default, desktop, mobile;

@layer reset {
  :host {
    display: block;

    .gcds-lang-toggle h2 {
      margin: 0;
      overflow: hidden;
      position: absolute;
      width: 0;
    }
  }
}

@layer default {
  :host .gcds-lang-toggle {
    gcds-link::part(link) {
      display: inline-block;
      padding: var(--gcds-lang-toggle-padding);
    }

    span {
      display: none;
    }

    abbr {
      text-transform: uppercase;
      text-decoration: none;
    }
  }
}

/* Note: viewport specific style decision */
@layer desktop {
  @media screen and (width >= 48em) {
    :host .gcds-lang-toggle {
      gcds-link::part(link) {
        font: var(--gcds-lang-toggle-font-desktop);
        padding-inline: 0 !important;
      }

      span {
        display: initial;
      }

      abbr {
        display: none;
      }
    }
  }
}

@layer mobile {
  @media screen and (width < 48em) {
    :host .gcds-lang-toggle gcds-link::part(link) {
      font: var(--gcds-lang-toggle-font-mobile);
    }
  }
}